<div class="glxy-nav-menu-trigger" [ngClass]="{ 'menu-open': isOpen }">
  <button class="glxy-nav-item-link" matRipple (click)="toggleOpen()">
    <div class="glxy-nav-item-layout">
      <mat-icon *ngIf="icon && !isSvg">{{ icon }}</mat-icon>
      <mat-icon *ngIf="icon && isSvg" [svgIcon]="icon"></mat-icon>
      <div class="glxy-nav-item-truncate">
        <ng-content></ng-content>
      </div>
      <ng-content select="glxy-nav-item-accessory"></ng-content>
    </div>
  </button>
</div>
<div class="glxy-nav-menu" [ngClass]="{ 'menu-open': isOpen }" [@openClose]="isOpen ? 'open' : 'closed'">
  <div class="glxy-nav-menu-items">
    <ng-content select="glxy-nav-item-list-items"></ng-content>
  </div>
</div>
